module.exports = __webpack_public_path__ + "static/media/YourLonelyNightsareOverBookCover.90fb61f6.jpg";